'use client';

import { useState } from 'react';
import { FaRegStar, FaStar } from 'react-icons/fa6';

const TabMenu = () => {
  const [activeTab, setActiveTab] = useState('Description');

  const navItems = [
    { name: 'Description' },
    { name: 'Additional Information' },
    { name: 'Reviews' },
  ];

  return (
    <div className="row">
      <div className="col-12">
        <div className="product-details__pill">
          {/* Navigation Tabs */}
          <ul className="nav nav-pills mb-3">
            {navItems.map((item, index) => (
              <li className="nav-item" key={index}>
                <button
                  className={`nav-link ${activeTab === item.name ? 'active' : ''}`}
                  onClick={() => setActiveTab(item.name)}
                >
                  {item.name}
                </button>
              </li>
            ))}
          </ul>

          {/* Tab Content */}
          <div className="tab-content">
            {activeTab === 'Description' && (
              <div className="tab-pane fade show active">
                <div className="product-details__content">
                  <h3>The Berries Advantage</h3>
                  <p>
                    Avocados, nature&apos;s treasure trove, offer a bounty of
                    essential nutrients. Explore the health benefits that make
                    avocados a must-have in your diet. or randomised words which
                    don&apos;t look even slightly believable. If you are going
                    to use a passage of Lorem Ipsum, you need to be sure there
                    isn&apos;t anything embarrassing hidden in the middle of
                    text.ve suffered alteration in some form, by injected
                    humour, or randomised words which don&apos;t look even
                    slightly believable you are going to use a passage of Lorem
                    Ipsum.
                  </p>
                  <h3>Culinary Versatility</h3>
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which
                    don&apos;t look even slightly believable. If you are going
                    to use a passage of Lorem Ipsum, you need to be sure there
                    isn&apos;t anything embarrassing hidden in the middle of
                    text.ve suffered alteration in some form, by injected
                    humour, or randomised words which don&apos;t look even
                    slightly believable. If you are going to use a passage of
                    Lorem Ipsum, you need to be sure.
                  </p>
                  <div className="row g-2 my-4">
                    <div className="col-lg-4">
                      <img src="/images/product/details/1.png" alt="recepie" />
                    </div>
                    <div className="col-lg-4">
                      <img src="/images/product/details/2.png" alt="recepie" />
                    </div>
                    <div className="col-lg-4">
                      <img src="/images/product/details/3.png" alt="recepie" />
                    </div>
                  </div>
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which
                    don&apos;t look even slightly believable.
                  </p>
                  <h3>Freshness Guaranteed</h3>
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which
                    don&apos;t look even slightly believable. If you are going
                    to use a passage of Lorem Ipsum, you need to be sure there
                    isn&apos;t anything embarrassing hidden in the middle of
                    text.ve suffered alteration in some form, by injected
                    humour, or randomised words which don&apos;t look even
                    slightly believable. If you are going to use a passage of
                    Lorem Ipsum, you need to be sure.
                  </p>
                  <h3>Picking the Perfect Berry</h3>
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which
                    don&apos;t look even slightly believable. If you are going
                    to use a passage of Lorem Ipsum, you need to be sure there
                    isn&apos;t anything embarrassing hidden in the middle of
                    text.ve suffered alteration in some form, by injected
                    humour, or randomised words which don&apos;t look even
                    slightly believable. If you are going to use a passage of
                    Lorem Ipsum, you need to be sure.
                  </p>
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which
                    don&apos;t look even slightly believable. If you are going
                    to use a passage.
                  </p>
                </div>
              </div>
            )}
            {activeTab === 'Additional Information' && (
              <div className="tab-pane fade show active">
                <div className="product-details__content">
                  <h3>Return Policy</h3>
                  <p>
                    Avocados, nature&apos;s treasure trove, offer a bounty of
                    essential nutrients. Explore the health benefits that make
                    avocados a must-have in your diet. or randomised words which
                    don&apos;t look even slightly believable. If you are going
                    to use a passage of Lorem Ipsum, you need to be sure there
                    isn&apos;t anything embarrassing hidden in the middle of
                    text.ve suffered alteration in some form, by injected
                    humour, or randomised words which don&apos;t look even
                    slightly believable you are going to use a passage of Lorem
                    Ipsum.
                  </p>
                  <h3>Shipping</h3>
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which
                    don&apos;t look even slightly believable. If you are going
                    to use a passage of Lorem Ipsum, you need to be sure there
                    isn&apos;t anything embarrassing hidden in the middle of
                    text.ve suffered alteration in some form, by injected
                    humour, or randomised words which don&apos;t look even
                    slightly believable. If you are going to use a passage of
                    Lorem Ipsum, you need to be sure.
                  </p>
                </div>
              </div>
            )}
            {activeTab === 'Reviews' && (
              <div className="tab-pane fade show active">
                <div className="product-details__review section-bg">
                  <div className="product-details__review-title">
                    <h2>Reviews</h2>
                  </div>
                  <div className="product-details__review-card">
                    <div className="product-details__review-author">
                      <div className="product-details__review-thumb">
                        <img
                          src="/images/testimonial/4.png"
                          alt="client image"
                        />
                      </div>
                      <div className="product-details__review-name">
                        <h4>Jenny Wilson</h4>
                        <p>February 11, 2025</p>
                      </div>
                    </div>
                    <div className="product-details__review-content">
                      <div className="rating">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                      </div>
                      <p>
                        Excellent variety, fresh produce, and prompt delivery.
                        My go-to for quality groceries. Highly recommend this
                        user-friendly and efficient grocery website!
                      </p>
                    </div>
                  </div>
                  <div className="product-details__review-card">
                    <div className="product-details__review-author">
                      <div className="product-details__review-thumb">
                        <img
                          src="/images/testimonial/5.png"
                          alt="client image"
                        />
                      </div>
                      <div className="product-details__review-name">
                        <h4>Dianne Russell</h4>
                        <p>March 6, 2025</p>
                      </div>
                    </div>
                    <div className="product-details__review-content">
                      <div className="rating">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <span>
                          <FaStar />
                        </span>
                        <span>
                          <FaStar />
                        </span>
                      </div>
                      <p>
                        Impressed with the organic selection, easy navigation,
                        and on-time deliveries. A reliable grocery partner for
                        quality and convenience.
                      </p>
                    </div>
                  </div>
                  <div className="product-details__review-card">
                    <div className="product-details__review-author">
                      <div className="product-details__review-thumb">
                        <img
                          src="/images/testimonial/6.png"
                          alt="client image"
                        />
                      </div>
                      <div className="product-details__review-name">
                        <h4>Darrell Steward</h4>
                        <p>December 19, 2025</p>
                      </div>
                    </div>
                    <div className="product-details__review-content">
                      <div className="rating">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <span>
                          <FaStar />
                        </span>
                      </div>
                      <p>
                        Outstanding service! From the diverse product range to
                        the user-friendly interface, shopping here is a
                        pleasure.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="product-details__review  product-details__review--add section-bg">
                  <div className="product-details__review-title">
                    <h2>Add a review</h2>
                  </div>
                  <div className="product-details__review-form">
                    <div className="rating">
                      <h4>Your Review</h4>
                      <FaRegStar />
                      <FaRegStar />
                      <FaRegStar />
                      <FaRegStar />
                      <FaRegStar />
                    </div>
                    <form action="/">
                      <div className="row g-4">
                        <div className="col-md-6">
                          <div>
                            <label htmlFor="name" className="form-label">
                              Name
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              id="name"
                              placeholder="Full Name"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div>
                            <label htmlFor="email" className="form-label">
                              Email
                            </label>
                            <input
                              className="form-control"
                              type="email"
                              id="email"
                              placeholder="Email here"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div>
                            <label htmlFor="textarea" className="form-label">
                              Message
                            </label>
                            <textarea
                              cols={30}
                              rows={5}
                              className="form-control"
                              id="textarea"
                              placeholder="Enter Your Message"
                              defaultValue={''}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        type="submit"
                        className="trk-btn trk-btn--border trk-btn--primary mt-4"
                      >
                        Send message
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabMenu;
